import { makeApiCall } from "../makeApiCall";
import { AdminService_URL } from "../Url";

export const StatCheckerActions = {
  STAT_CHECKER_SUCCESS: "STAT_CHECKER_SUCCESS",
  STAT_CHECKER_FAILURE: "STAT_CHECKER_FAILURE",
  CHECKER_DASHBOARD_SUCCESS: "CHECKER_DASHBOARD_SUCCESS",
  CHECKER_DASHBOARD_FAILURE: "CHECKER_DASHBOARD_FAILURE",
};

////? Checker stat service

export function StatCheckerSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: StatCheckerActions.STAT_CHECKER_SUCCESS,
      payload: props,
    });
  };
}

export function StatCheckerFailureAction(error) {
  return {
    type: StatCheckerActions.STAT_CHECKER_FAILURE,
    payload: error,
  };
}

// Cancel Order
export function StatCheckerThunk(props, warehouseIds) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/fetchCheckerPwaStats?fromDate=${
    props.fromDate
  }&toDate=${props.toDate}${
    props.isExportCsv ? `&isExportCsv=${props.isExportCsv}` : ""
  }&isFreeCheckerAvailable=${props.isFreeCheckerAvailable}${
    props.active ? `&active=${props.active}` : ""
  }`;

  // const postUrl = props.isExportCsv
  //   ? `https://1dad8dd3-5d46-46b3-bf75-9e646bee324b.mock.pstmn.io/fetchCheckerPwaStats?fromDate=${props.fromDate}&toDate=${props.toDate}&isExportCsv=${props.isExportCsv}`
  //   : `https://1dad8dd3-5d46-46b3-bf75-9e646bee324b.mock.pstmn.io/fetchCheckerPwaStats?fromDate=${props.fromDate}&toDate=${props.toDate}`;
  return makeApiCall(
    postUrl,
    StatCheckerSuccessAction,
    StatCheckerFailureAction,
    "POST",
    warehouseIds,
    reqHeader,
    props.history
  );
}

////? Checker dashboard Service

export function checkerDashboardSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: StatCheckerActions.CHECKER_DASHBOARD_SUCCESS,
      payload: props,
    });
  };
}

export function checkerDashboardFailureAction(error) {
  return {
    type: StatCheckerActions.CHECKER_DASHBOARD_FAILURE,
    payload: error,
  };
}

export function CheckerDashboardThunk(props, warehouseIds) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/getCheckerDashboard?fromDate=${props.fromDate}&toDate=${props.toDate}&isFreeCheckerAvailable=${props.isFreeCheckerAvailable}`;
  // const postUrl = `https://1dad8dd3-5d46-46b3-bf75-9e646bee324b.mock.pstmn.io/getCheckerDashboard?fromDate=${props.fromDate}&toDate=${props.toDate}`;
  return makeApiCall(
    postUrl,
    checkerDashboardSuccessAction,
    checkerDashboardFailureAction,
    "POST",
    warehouseIds,
    reqHeader,
    props.history
  );
}
